<ng-container *ngIf="vm$ | async as vm">
  <div class="pto-main-container">
    <div class="pto-header-container">
      <span class="pto-header-title">Projects Overview</span>
    </div>
    <div class="spinner-border text-primary summary-question-spinner" role="status" *ngIf="vm.loading"></div>
    <div class="pto-body-container" *ngIf="!vm.loading">
      <app-highlights-and-trends></app-highlights-and-trends>
      <app-project-health></app-project-health>
      <app-project-cards
        [projectCards]="vm.projects"
        ></app-project-cards>
    </div>
  </div>
</ng-container>
